// Shapes returned by GET /super-admin/signups and /super-admin/signups/options
// (CITS-Server src/controllers/signups.controller.js).

export type StepStatus = 'waiting' | 'running' | 'done' | 'failed'
export interface SetupStep { key: string; label: string; status: StepStatus; at: string | null; error: string | null }

export interface SignupRow {
  id: string
  companyName: string
  slug: string
  status: string
  provisioningStatus: string
  tier: string
  createdAt: string
  trialEndsAt: string | null
  daysLeft: number | null
  contact: { name: string | null; email: string | null; phone: string | null }
  industry: string | null
  employeeCount: number | null
  source: string | null
  signals: { personalEmail: boolean; emailConfirmed: boolean; captcha: boolean; ip: string | null }
  steps: SetupStep[]
  error: string | null
  review: { decision: 'approved' | 'declined' | 'asked'; by: string; at: string; note: string | null } | null
  lastSignInAt: string | null
}

export interface SignupsResponse {
  review: SignupRow[]
  setup: SignupRow[]
  trials: SignupRow[]
  closed: SignupRow[]
  counts: { review: number; setup: number; failed: number; trials: number; closed: number }
}

export interface Composer {
  variant: string
  subject: string | null
  note: string
  sections: { app: boolean; firstSteps: boolean; support: boolean }
  replyTo: string | null
  bcc: string[] | string | null
}

export interface ComposerOptions {
  tiers: string[]
  trialLengths: number[]
  steps: Array<{ key: string; label: string }>
  features: Array<{ key: string; name: string; category: string; requiresTier: string; description: string | null }>
  variants: Array<{ key: string; label: string; subject: string }>
  defaults: Composer
  variables: string[]
}

/** Where tenant workspaces live — acme.<this>. */
export const PORTAL_DOMAIN: string = import.meta.env.VITE_TRIAL_PORTAL_DOMAIN || 'citstime.app'

export const TIER_ORDER = ['basic', 'standard', 'premium', 'enterprise']
export const tierLabel = (t: string) => t.charAt(0).toUpperCase() + t.slice(1)

export function ago(iso: string | null): string {
  if (!iso) return '—'
  const s = (Date.now() - new Date(iso).getTime()) / 1000
  if (s < 60) return 'just now'
  if (s < 3600) return `${Math.round(s / 60)} min ago`
  if (s < 86400) return `${Math.round(s / 3600)} h ago`
  const d = Math.round(s / 86400)
  return d === 1 ? 'yesterday' : `${d} days ago`
}

export function shortDate(iso: string | null): string {
  if (!iso) return '—'
  return new Date(iso).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
}

export function errMsg(err: unknown, fallback: string): string {
  return (err as { response?: { data?: { message?: string } } })?.response?.data?.message || fallback
}
